import { Post } from 'model';
import { FormValidationRules } from '../hooks/useFormValues';

export const PostEditRules: FormValidationRules<Post> = {
	topic: {
		rules: {
			required: {
				value: true,
				message: 'Post Topic is required'
			},
			maxLength: {
				value: 20,
				message: 'Must be less than {value} characters'
			},
			pattern: {
				value: /^\S*$/,
				message: 'Must be one word'
			}
		}
	},
	title: {
		rules: {
			maxLength: {
				value: 80,
				message: 'Must be less than {value} characters'
			},
			minLength: {
				value: 10,
				message: 'Must be more than {value} characters'
			}
		}
	},
	contents: {
		rules: {
			maxLength: {
				value: 10000,
				message: 'Must be less than {value} characters'
			},
			required: {
				value: true,
				message: 'Post content is required'
			}
		}
	}
};
